/* eslint-disable import/prefer-default-export */
import moment from "moment";
import { AssignmentDetails } from "../ProposalDetails/interfaces";

const prepareAssignmentRequestBody = (leadId: string, fieldValues: AssignmentDetails) => ({
  leadId,
  assignmentClause: {
    assigneeName: fieldValues?.assignorName || null,
    assignmentAt: fieldValues?.assigmentAt || null,
    signedDate:
      (fieldValues?.signedDate &&
        moment(fieldValues?.signedDate, "DD/MM/YYYY")?.format("YYYY-MM-DD")) ||
      null,
    place: fieldValues?.placeCode || null,
    reasonForAssignment: fieldValues?.reasonForAssigment || null,
    witnessName: fieldValues?.witnessName || null,
    address: fieldValues?.address || null,
    pincode: fieldValues?.pincode || null,
    occupation: fieldValues?.occupationCode || null,
    witnessEmail: fieldValues?.witnessEmail || null,
    witnessMobile: fieldValues?.witnessMobile || null,
    witnessSignature: fieldValues?.witnessSignature || null
  }
});

export { prepareAssignmentRequestBody };
